import { render, staticRenderFns } from "./mfa-container.vue?vue&type=template&id=232b1ff8"
import script from "./mfa-container.vue?vue&type=script&lang=js"
export * from "./mfa-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports